import { createContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
export const defaultDialogContext = {
  use: 'default',
  headerCallback: emptyFunction
};
export const DialogContext = /*#__PURE__*/createContext(defaultDialogContext);
const {
  Provider
} = DialogContext;
export { Provider as DialogContextProvider };